import { renderDate } from '../utility/personTabGridHelper';

export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const TAG_PARENT_TYPE = 'Person';

export const TAG_GRID_COLUMNS = [
  { field: 'ptsTagID', headerName: 'Tag ID', width: 130 },
  { field: 'Type', headerName: 'Type', width: 150 },
  { field: 'Value', headerName: 'Description', width: 220 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
